export default __webpack_public_path__ + "static/media/back-2.7bb24cd4.png";